import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { NameUtils } from '@core/utils/name.utils';
import { DonationApi } from '@shared/donation/donation-api.service';
import { PausedDonation } from '@shared/paused-donation/paused-donation';

@Component({
  selector: 'app-paused-donations-widget',
  templateUrl: './paused-donations-widget.component.html',
  styleUrls: ['./paused-donations-widget.component.scss'],
  imports: [
    MatTable,
    MatHeaderCell,
    MatCell,
    MatColumnDef,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    RouterLink,
    DatePipe,
    CurrencyPipe,
  ],
})
export class PausedDonationsWidgetComponent implements OnInit {
  pausedDonations!: PausedDonation[];
  displayedColumns = ['donor', 'emailaddress', 'amount', 'latestcomment', 'pausedon'];

  nameUtils = NameUtils;

  constructor(private readonly donationApi: DonationApi) {}

  ngOnInit(): void {
    this.donationApi.findPausedDonations().subscribe(value => {
      this.pausedDonations = value.sort((a, b) => new Date(b.pausedOn).getTime() - new Date(a.pausedOn).getTime());
    });
  }
}
